import { NAME } from './constants';

export const RESET = `${NAME}/RESET`;
export const SET_LEADS = `${NAME}/SET_LEADS`;
export const APPEND_LEADS = `${NAME}/APPEND_LEADS`;
export const RESET_LEADS = `${NAME}/RESET_LEADS`;
export const SET_SORT_VALUE = `${NAME}/SET_SORT_VALUE`;

export const CHANGE_QUICK_FILTER = `${NAME}/CHANGE_QUICK_FILTER`;
export const CHANGE_SELECTED_DAY_OF_NEXT_DAYS = `${NAME}/CHANGE_SELECTED_DAY_OF_NEXT_DAYS`;
export const SET_AVAILABLE_LEADS = `${NAME}/SET_AVAILABLE_LEADS`;
export const SET_INPROGRESS_AND_DEADLINE_LEAD_OVERVIEW = `${NAME}/SET_INPROGRESS_AND_DEADLINE_LEAD_OVERVIEW`;
export const SET_INPROGRESS_LEADS_BY_TYPE = `${NAME}/SET_INPROGRESS_LEADS_BY_TYPE`;
export const APPEND_INPROGRESS_LEADS_BY_TYPE = `${NAME}/APPEND_INPROGRESS_LEADS_BY_TYPE`;
export const SET_SELECTED_INPROGRESS_TASKTYPEID = `${NAME}/SET_SELECTED_INPROGRESS_TASKTYPEID`;
export const SET_SEARCHED_WITH_CUSTOM_FILTER = `${NAME}/SET_SEARCHED_WITH_CUSTOM_FILTER`;
export const SET_ON_DETAIL_THROUGH_MARKETPLACE_ROW = `${NAME}/SET_ON_DETAIL_THROUGH_MARKETPLACE_ROW`;
